export default __webpack_public_path__ + "static/media/flag-lt.08e75a7b.svg";